import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { HttpService } from 'src/app/services/http/http.service';
import { ExceldataService } from 'src/app/services/exceldata.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ErrorStatusDialogComponent } from '../error-status-dialog/error-status-dialog.component';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { ThrowStmt } from '@angular/compiler';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { DriveService } from 'src/app/services/drive/drive.service';

@Component({
  selector: 'app-excel-upload-registration',
  templateUrl: './excel-upload-registration.component.html',
  styleUrls: ['./excel-upload-registration.component.scss']
})

export class ExcelUploadRegistrationComponent implements OnInit {
  arrayBuffer: any;
  excelData:any;
  data: {};
  city=[];
  EmailUserKeyDTO=[];
 postdata=new Array();
  constructor(private https:HttpService,
    private exceldataService:ExceldataService,
    public dialog: MatDialog,
    private snackBarService: MatSnackBar ,
    private campaignService: CampaignService,
    private driveService:DriveService,
    private utility:UtilityService) { 
    console.log(this.excelData);
  }
  ngOnInit() {
  }
  uploadHandler(event,data){
    this.postdata =[];
  //  console.log('event---->',event);
  //  console.log('data--->',data);
   const file: File = event.target.files[0];
   console.log('file is ',file);
   
   event.target.value = null;
   const fileReader = new FileReader();
   fileReader.readAsArrayBuffer(file);
   // console.log('file',file);

   fileReader.onload = () => {

     this.arrayBuffer = fileReader.result;
     const tempData = new Uint8Array(this.arrayBuffer);
     const arr = new Array();

     for (let i = 0; i !== tempData.length; ++i) {
       arr[i] = String.fromCharCode(tempData[i]);
     }

     const bstr = arr.join('');
     const workbook = XLSX.read(bstr, { type: 'binary' });
     const first_sheet_name = workbook.SheetNames[0];
     const worksheet = workbook.Sheets[first_sheet_name];

     this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
  //  console.log('excel data-->',this.excelData);
  //  for(let i of this.excelData.length){
  //   this.postdata.pop();
  //   console.log("pop");
  //  }
   
for(const user of this.excelData){
  this.data = {
    collegeCity : user['Engineering College City'],
    collegeState : user['Engineering College State'],
    discipline: user['Engineering Stream'],
    emailId:user['Email Id'],
    fullName:user['First Name'],
    gender:user['Gender'],
    currentYear:user['Year Of Education'],
    userKey:user['User Key']
   }

   if(this.excelData.user !== this.data){
     this.utility.openSnackBar("This file is invalid")
   }
   //console.log('model to be register',this.data['userKey']);
   //this.postdata.pop();
  // this.postdata.clear();
  if(this.data['collegeCity']!==undefined && this.data['collegeState']!=undefined && this.data['discipline']!=undefined  
  && this.data['emailId']!=undefined 
  && this.data['gender']!=undefined 
  &&  this.data['currentYear']!=undefined 
  && this.data['userKey']!== undefined && this.data['fullName'] !== undefined){
    // console.log('user key--->',this.data['userKey']);
   this.postdata.push(this.data);
   

  this.exceldataService.changeMessage(this.postdata)
   
   console.log('model to be register',this.data);
   this.campaignService.registration(this.data, 'ETCS3.0').subscribe(data=>
    {
      // console.log('registration--------->',(data as any).status);
     if((data as any).status === '200') {
        this.campaignService.emailRegistrationLink(user['Email Id']).subscribe(link => {
          console.log('sending link--->', link);
        },
        error => {
          console.log('Error:', error);
        }
        );
     }
    },
    Error => {
      console.log('error', Error);
      this.utility.openSnackBar(Error.error.message);
    }
    );
  }
  // this.https.sendRegistrationLink(user['Email Id']).subscribe(data => {
  //   console.log(data);
  // });
}



  }

   
  }
  uploadCityHandler(event, data){
  this.city = [];
    const file: File = event.target.files[0];
    event.target.value = null;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    // console.log('file',file);
 
    fileReader.onload = () => {
 
      this.arrayBuffer = fileReader.result;
      const tempData = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
 
      for (let i = 0; i !== tempData.length; ++i) {
        arr[i] = String.fromCharCode(tempData[i]);
      }
 
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
    // console.log('excel data-->',this.excelData);
    for(const data of this.excelData){
      // let map = new Map<string, string>();
      // const cityMap= [];
      // map.set(data['Email Id'],data['City']);
    this.data = {
      cityMap: {[data['Email Id']]: data['City']}
    };
    this.city.push(this.data);
    }
    console.log(this.city);
    this.https.cityUpdate(this.city).subscribe(data => {
      console.log(data);
      
      if(data.data.error===true){
        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: {
            response: data,
            errorFor: 'cityUpdate'
          }
        });
      }else{
        this.snackBarService.open("data updated successfully",'close',{duration:3000});
      }
    }
    );
}}
uploadUserKeyEmailId(event,data){
  this.EmailUserKeyDTO=[];
  const file: File = event.target.files[0];
  
   
   event.target.value = null;
   const fileReader = new FileReader();
   fileReader.readAsArrayBuffer(file);
   // console.log('file',file);

   fileReader.onload = () => {

     this.arrayBuffer = fileReader.result;
     const tempData = new Uint8Array(this.arrayBuffer);
     const arr = new Array();

     for (let i = 0; i !== tempData.length; ++i) {
       arr[i] = String.fromCharCode(tempData[i]);
     }

     const bstr = arr.join('');
     const workbook = XLSX.read(bstr, { type: 'binary' });
     const first_sheet_name = workbook.SheetNames[0];
     const worksheet = workbook.Sheets[first_sheet_name];

     this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
     for(const excelIp of this.excelData){
      
       
       this.data={
        emailId:excelIp['Email Id'],
        userKey:excelIp['User Key']
       }
       console.log('excel data',this.data);
       
    this.EmailUserKeyDTO.push(this.data);
       
     }
    
     console.log(this.data);
     this.driveService.userKeyCorrection(this.EmailUserKeyDTO).subscribe(response=>{
       console.log(response);
       if(response.data.error===true){
        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: {
            response: response,
            errorFor: 'emailUserKey'
          }
        });
         
       }
       else{
        this.snackBarService.open(response.message,'close',{duration:3000});
       }
       
     })
     
}
  }
}
